import React__default, { useState, useEffect } from 'react';
import { shallow as shallow$1 } from '../../../../../node_modules/zustand/esm/shallow.js';
import { useSharedStateStore } from '../../../../store/sharedState.js';
import { useUnmount } from '@fabric-app/hooks/useUnmount';

const useMediaPlayerControls = (resourceId) => {
  const mediaElementRef = React__default.useRef(null);
  const [localMediaPlaying, setLocalMediaPlaying] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const { playingResourceId, mediaTimestamp, setPlayingResourceId, setMediaTimestamp } = useSharedStateStore((state) => ({
    playingResourceId: state.playingResourceId,
    setPlayingResourceId: state.setPlayingResourceId,
    mediaTimestamp: state.mediaTimestamp,
    setMediaTimestamp: state.setMediaTimestamp
  }), shallow$1);
  const onLoad = (e) => {
    if (e.currentTarget !== mediaElementRef.current) return;
    setIsReady(true);
  };
  const onPlay = (e) => {
    if (e.currentTarget !== mediaElementRef.current) return;
    if (playingResourceId !== resourceId) {
      e.currentTarget.currentTime = 0;
    }
    setPlayingResourceId(resourceId);
    setLocalMediaPlaying(true);
    setMediaTimestamp(e.currentTarget.currentTime);
  };
  const onPause = (e) => {
    if (e.currentTarget !== mediaElementRef.current) return;
    setLocalMediaPlaying(false);
    setMediaTimestamp(e.currentTarget.currentTime);
  };
  const onSeeked = (e) => {
    if (e.currentTarget !== mediaElementRef.current) return;
    setMediaTimestamp(e.currentTarget.currentTime);
  };
  const onTimeUpdate = (e) => {
    if (e.currentTarget !== mediaElementRef.current) return;
    setMediaTimestamp(e.currentTarget.currentTime);
  };
  useUnmount(() => {
    setPlayingResourceId(null);
    setLocalMediaPlaying(false);
    setMediaTimestamp(null);
  });
  const mediaEl = mediaElementRef.current;
  useEffect(() => {
    if (playingResourceId !== resourceId && mediaElementRef.current && !mediaElementRef.current.paused) {
      mediaElementRef.current?.pause();
    }
  }, [
    playingResourceId,
    resourceId
  ]);
  useEffect(() => {
    if (!mediaTimestamp || playingResourceId !== resourceId) return;
    if (mediaEl && Math.abs(mediaEl.currentTime - mediaTimestamp) > 0.2) {
      mediaEl.currentTime = mediaTimestamp;
    }
  }, [
    mediaTimestamp,
    mediaEl,
    playingResourceId,
    resourceId
  ]);
  return {
    mediaElementProps: {
      onPlay,
      onPause,
      onSeeked,
      onTimeUpdate,
      preload: "metadata",
      onLoadedMetadata: onLoad
    },
    mediaElementRef,
    localMediaPlaying,
    mediaTimestamp,
    isReady
  };
};

export { useMediaPlayerControls };
//# sourceMappingURL=useMediaPlayerControls.js.map
